import React from 'react';
import { motion } from 'motion/react';
import { Globe, TrendingUp, Users, Zap, CheckCircle2, Target, Award } from 'lucide-react';
import { STATS } from '../data';
import Seo from '../components/Seo';
import { PAGE_METADATA, getImpactStructuredData } from '../seo/pageMetadata';

const Impact = () => {
  return (
    <>
      <Seo {...PAGE_METADATA.impact} structuredData={getImpactStructuredData()} />
      <div className="pt-32 pb-24">
        <section className="px-6 max-w-7xl mx-auto text-center mb-20">
          <motion.div initial={{ opacity: 0, y: 20 }} animate={{ opacity: 1, y: 0 }}>
            <div className="inline-flex items-center gap-2 bg-royal-accent border border-amber-200 px-4 py-2 rounded-full mb-6">
              <TrendingUp className="w-4 h-4 text-royal-purple" />
              <span className="text-royal-purple text-[10px] font-black uppercase tracking-[0.2em]">Our Impact</span>
            </div>
            <h1 className="text-5xl md:text-7xl font-display font-black text-royal-dark tracking-tighter mb-6">
              Building a <span className="text-royal-purple">Movement</span>
            </h1>
            <p className="text-lg text-slate-500 max-w-3xl mx-auto font-medium">
              At Delight Business Empowerment, we are driven by the belief that when women are empowered, society thrives.
              Every contest we host is designed to create hope, unlock opportunities, and launch the next generation of
              female leaders.
            </p>
          </motion.div>
        </section>

        <section className="px-6 max-w-7xl mx-auto">
          <div className="grid md:grid-cols-3 gap-10">
            {[
              {
                title: 'Transparency',
                icon: <Target className="w-8 h-8" />,
                desc: 'We are committed to transparency in everything we do, ensuring every resource reaches its intended potential.',
              },
              {
                title: 'Impact',
                icon: <TrendingUp className="w-8 h-8" />,
                desc: 'Our goal is to create lasting impact by building confidence, encouraging innovation, and promoting sustainable growth.',
              },
              {
                title: 'Excellence',
                icon: <Award className="w-8 h-8" />,
                desc: 'We strive for excellence, providing practical support and valuable exposure to help people build a better future.',
              },
            ].map((item, idx) => (
              <div key={idx} className="bg-white p-10 rounded-[3rem] border border-slate-100 shadow-xl text-center">
                <div className="w-16 h-16 bg-royal-accent rounded-2xl flex items-center justify-center text-royal-purple mx-auto mb-6">
                  {item.icon}
                </div>
                <h3 className="text-2xl font-display font-black text-royal-dark mb-4">{item.title}</h3>
                <p className="text-slate-500 font-medium leading-relaxed">{item.desc}</p>
              </div>
            ))}
          </div>
        </section>

        <section className="mt-32 px-6 max-w-5xl mx-auto bg-royal-dark rounded-[4rem] p-16 text-white text-center">
          <h2 className="text-3xl md:text-4xl font-display font-black mb-8">A Movement of Transformation</h2>
          <p className="text-royal-accent/70 text-xl leading-relaxed font-medium">
            Whether you are an aspiring model, a visionary entrepreneur, or a creative leader, Delight Business Empowerment is
            here to support your journey. We are building more than a competition and we are building a movement of
            empowerment, transformation, and possibility.
          </p>
        </section>
      </div>
    </>
  );
};

export default Impact;
